import { createStore, applyMiddleware, compose } from 'redux';
import { middleware as reduxPackMiddleware } from 'redux-pack';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import createRavenMiddleware from 'ps-components/redux/middleware/ravenMiddleware';
import createApiClientMiddleware from 'ps-components/redux/middleware/clientMiddleware';

let puppeteer = false;
if (
  typeof window === 'object' &&
  window &&
  window.clientInformation &&
  window.clientInformation.userAgent === 'puppeteer'
) {
  puppeteer = true;
}

let composeEnhancers = compose;
if (puppeteer === false && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const configureStore = (preloadedState, apiClient) => {
  // Lab's version of reduxPackMiddleware
  //   too much code written in each pattern to drop usage (and bundle size is trivial)
  //   and added to MarketPay to allow compatibility of modules across apps

  const apiClientMiddleware = createApiClientMiddleware(apiClient);

  const middleware = [thunk, reduxPackMiddleware, apiClientMiddleware, createRavenMiddleware()];

  const store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(...middleware)));

  // This is a hack that is ONLY to be used to dispatch the
  // logout and setError functions within the ApolloClient.
  window.__dispatchReduxStore = store.dispatch;

  return store;
};

export default configureStore;
